export enum ConfigurationsConstants {
  DEFAULT_TIMEZONE = 'US/Eastern',
  SET_SERVICE_CONFIG = 'configurations/SET_SERVICE_CONFIG',
  SET_TIME_ZONE = 'configurations/SET_TIME_ZONE',
  SET_CAD_IMPORT_CONFIG = 'configurations/SET_CAD_IMPORT_CONFIG',
  SET_EKG_IMPORT_CONFIG = 'configurations/SET_EKG_IMPORT_CONFIG',
  SET_COMMAND_FACILITY_CONFIG = 'configurations/SET_COMMAND_FACILITY_CONFIG',
  SET_COMMAND_FACILITY_CHART_DEFAULTS = 'configurations/SET_COMMAND_FACILITY_CHART_DEFAULTS',
  SET_COMMAND_FACILITY_PROCEDURE_DEFAULT_ACTION = 'configurations/SET_COMMAND_FACILITY_PROCEDURE_DEFAULT_ACTION',
  SET_DATA_POINTS_CONFIG = 'configurations/SET_DATA_POINTS_CONFIG',
  SET_IS_SERVICE_CONFIG_LOADING = 'configurations/SET_IS_SERVICE_CONFIG_LOADING',
  RESET_CONFIG = 'configurations/RESET_CONFIG',
  SET_SERVICES_BILLING_CONFIG = 'configurations/SET_SERVICES_BILLING_CONFIG',
  SET_AGENCY_NUMBER_CONFIG = 'configurations/SET_AGENCY_NUMBER_CONFIG',
  SET_AGENCY_NUMBER = 'configurations/SET_AGENCY_NUMBER',
  SAVE_AGENCY_NUMBER = 'configurations/SAVE_AGENCY_NUMBER',
  SET_DATASET_DETERMINATION_CONFIG = 'configurations/SET_DATASET_DETERMINATION_CONFIG',
  SET_TEXAS_EXPORT_CONFIG = 'configurations/SET_TEXAS_EXPORT_CONFIG',
  SET_TEXAS_WRISTBAND_REPORT_TYPE_CONFIG = 'configurations/SET_TEXAS_WRISTBAND_REPORT_TYPE_CONFIG',
  SET_INITIAL_EXPORT_DATASETS = 'configurations/SET_INITIAL_EXPORT_DATASETS',
  SET_APP_SETTINGS_ENTRIES = 'configurations/SET_APP_SETTINGS_ENTRIES',
}
